<template>
  <div class="loading-box">
    <div class="loading-header mb-3" v-if="heading">
      <div class="loading-heading" v-if="!noHeadingMain"></div>
      <div class="loading-text-line"></div>
      <div class="loading-text-line"></div>
    </div>
    <div :class="{
      'loading-body': box,
      'bs': box
      }" v-if="paragraphs > 0">
      <div class="loading-body-cell" v-for="paragraph in paragraphs" :key="paragraph">
        <div :class="{
          'loading-text-line': true,
          'loading-text-line-big': bigLines
          }" v-for="line in lines" :key="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      type: Boolean,
      default: true
    },
    noHeadingMain: {
      type: Boolean,
      default: false
    },
    lines: {
      type: Number,
      default: 4
    },
    bigLines: {
      type: Boolean,
      default: false
    },
    paragraphs: {
      type: Number,
      default: 6
    },
    box: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.loading-box {
  .loading-body {
    padding: 1.25rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    border-radius: 0.25rem;
  }

  .loading-body-cell {
    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }

  @keyframes placeHolderShimmer {
    0%{
      background-position: -468px 0
    }
    100%{
      background-position: 468px 0
    }
  }

  .animated-background-light {
    animation-duration: 1.25s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #F6F6F6;
    background: linear-gradient(to right, #F6F6F6 8%, #F0F0F0 18%, #F6F6F6 33%);
    background-size: 800px 104px;
    position: relative;
  }

  .animated-background-dark {
    animation-duration: 1.25s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #ECECEC;
    background: linear-gradient(to right, #ECECEC 8%, #E6E6E6 18%, #ECECEC 33%);
    background-size: 800px 104px;
    position: relative;
  }

  .loading-text-line {
    border-radius: 0.25rem;
    height: 12px;
    width: 100%;
    margin: 6px 0;
    @extend .animated-background-light;

    &.loading-text-line-big {
      height: 24px;
      margin: 12px 0;
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .loading-header {
    .loading-heading {
      border-radius: 0.25rem;
      height: 1.5rem;
      width: 10rem;
      margin-bottom: 1rem;
      @extend .animated-background-dark;
    }

    .loading-text-line {
      @extend .animated-background-dark;
    }
  }
}

.text-center {
  .loading-heading {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
